angular.module('payments.constants', [])
    .constant('paymentSessionTypeEnum', {
        Booking: 1,
        Payment: 2
    });